/* @flow */

import Edit from './Edit';
import View from './View';

export type HomeContentHeader = {
  title: string,
};

export const getEditComponent = () => Edit;
export const getViewComponent = () => View;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/home/index.js